module.exports = __webpack_public_path__ + "build/assets/TruenoBd-4fe4fdfca9ae8a190b3c2c188823a939.woff";